import { Component } from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterLegalNoticeComponent } from '../../shared/components/footer-legal-notice.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [HeaderComponent, RouterOutlet, FooterComponent, FooterLegalNoticeComponent],
})
export class LayoutComponent {
  constructor() {}
}
